const CONFIG = {
    BASE_URL: 'https://zakiulfikri.pythonanywhere.com',
    // BASE_URL: 'http://localhost:8000'
};

export default CONFIG;